import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import _filter from 'lodash/filter';

class StacklaWidget extends PureComponent {

  componentDidMount(){
    if (process.env.REACT_APP_ENV === "production") {
      if(typeof window.Stackla !== 'undefined'){
        window.Stackla.WidgetManager.rebuild();
      }
    }
  }

  sectorsWithStackla(){

    const { itineraries:{sectors, cities} } = this.props;

    let arr = [];

    for(let j = 0; j < sectors.length; j++){
      let city = _filter(cities, ['ctfl_id', sectors[j].city_ctfl_id])[0];
      arr.push(city.stacklaTag);
    }

    return arr;
  }

  render(){

    const _stacklaTag = this.sectorsWithStackla()

    if (process.env.REACT_APP_ENV === "production") {
      return (
        <div
        className="stackla-widget"
        data-tags={_stacklaTag}
        data-alias="busabout.stackla.com"
        data-ct=""
        data-hash="5bdc7cd4205fc"
        data-id="49009"
        data-title="CYOA - 2019"
        data-ttl="30"
        style={{width: "100%",  overflow: "hidden"}}>
        </div>
      )
    }else{
      return <p style={{textAlign:"center"}}>( Development environment - stackla disabled. Boo! )</p>
    }

  }

}


function mapStateToProps(state){
  return {
    itineraries:state.itineraries.data
  }
}

export default connect(mapStateToProps, null)(StacklaWidget);



// WEBPACK FOOTER //
// ./src/components/itinerary/components/stackla-widget.js